import { createFileRoute } from "@tanstack/react-router";
import { ScheduleDetailPage } from "@client/components/settings/job-manager/schedule/schedule-detail-page";

export const Route = createFileRoute(
  "/_app/settings/job-manager/schedule/$scheduleId",
)({
  component: ScheduleDetailPage,
});
